import classNames from 'classnames';
import { ChipsFilter } from 'src/types';
import css from './filter-chips.module.scss';

interface ChipsProps<T> {
  selectedFilters: T[];
  onClick: (filter: T) => void;
  onClear: () => void;
  className?: string;
}

function FilterChips({ selectedFilters, onClick, onClear, className }: Readonly<ChipsProps<ChipsFilter>>) {
  return (
    <div className={classNames(css.filterChips, { [css.className]: className })}>
      <div className={css.chipsList}>
        {selectedFilters?.map((filter, i) => (
          <div key={filter?.id ?? i} className={classNames(css.chips)}>
            <button onClick={() => onClick(filter)}>&#215;</button> {filter?.name}
          </div>
        ))}
      </div>
      <button className={css.clearBtn} onClick={onClear}>
        Зняти все
      </button>
    </div>
  );
}

export default FilterChips;
